import React, { Component } from 'react'
import { StaticBox, FlowTable, Modal, LinkedInput, LinkedInputGroup, NoContentBox } from 'components/basic'
import { notify, date } from 'helpers'
import http from 'API/http'
import Datetime from 'react-datetime'
import { default as moment } from 'moment-timezone'
import CharacteristicsWidget from './CharacteristicsWidget'

class AccessOrders extends Component {
  constructor (props) {
    super(props)
    this.state = {
      orders: [],
      stateFilter: '',
      loading: true,
      order: {},
      editModal: false
    }
  }
  componentDidMount () {
    this.getOrders(this.props.id)
  }
  componentWillReceiveProps (props) {
    if (props.updated === this.props.updated) return false
    this.getOrders(props.id)
  }
  async getOrders (id) {
    this.setState({loading: true})
    var [err, res] = await http.get('2.4/orders', {
      accessId: id,
      rich: true
    })
    if (err) return this.setState({loading: false})
    this.setState({orders: res.data, loading: false})
  }
  deleteOrder (order) {
    notify.deleteConfirm('This will delete this order', async confirmed => {
      if (!confirmed) return
      var [err, res] = await http.delete('2.4/orders/' + order.orderId)
      if (err) return notify.alert('', res.cause, 'error')
      notify.alert('', 'Order deleted!', 'success')
      this.props.callback()
    })
  }
  async updateOrder (order) {
    if (this.state.order.operation === 'ACTIVATE') {
      var valid = await new Promise((resolve, reject) => { this.form.check(resolve) })
      var characteristics = {}
      Object.entries(this.setCharacteristics()).map(([key, value]) => {
        if (value.required && value.value.length === 0) {
          notify.warn('Value is required for ' + key)
          valid = false
        }
        characteristics[key] = value.value
      })
      if (!valid) return
    }
    this.setState({updating: true})
    order.requestedDateTime = moment(order.requestedDateTime).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
    var [err, res] = await http.put('2.4/orders/' + order.orderId, {...order, accessId: this.props.id, characteristics: characteristics})
    if (err) return notify.alert('', res.cause, 'error')
    notify.alert('', 'Order updated!', 'success')
    this.setState({updating: false, editModal: false, order: {}})
    this.getOrders(this.props.id)
  }

  render () {
    return (
      <StaticBox cols={12} icon='first-order' title='Orders'>
        <FlowTable hideHeaders emptyIcon='fa-first-order' emptyText='No Active Orders' loading={this.state.loading} paginatable={5} data={this.state.orders.map(order => [
          <a className={(order.state === 'RECEIVED' ? 'table-link' : 'hidden')} onClick={() => this.setState({editModal: true, order: order}, console.log(order))}><i className='fa fa-edit' /></a>,
          order.operation,
          <span className={'label orders-label label-' + (order.state === 'DONE_FAILED' ? 'danger' : (order.state === 'IN_PROGRESS' ? 'warning' : 'success'))}><b>{order.state}</b></span>,
          order.service,
          date.format(order.requestedDateTime),
          <a className={(order.state === 'RECEIVED' ? 'table-link' : 'hidden')} onClick={() => this.deleteOrder(order)}><i className='fa fa-trash-o' /></a>
        ])}>
          <tr>
            <th className='buttons' />
            <th className='buttons'>Operation</th>
            <th style={{'width': '120px'}}>State</th>
            <th>Service</th>
            <th>Operationtime</th>
            <th className='buttons' />
          </tr>
        </FlowTable>
        <Modal noOverflow title={'Edit ' + this.state.order.operation + ' on service ' + this.state.order.service} isOpen={this.state.editModal} close={e => this.setState({editModal: false, order: {}})} buttons={[
            { disabled: this.state.updating, icon: (this.state.updating ? 'fa-circle-o-notch fa-spin' : ''), text: (this.state.updating ? 'Updating' : 'Update'), event: e => this.updateOrder(this.state.order) }
        ]}>
          <label>Operation time</label>
          <Datetime value={moment(this.state.order.requestedDateTime).format('YYYY-MM-DD HH:mm')} minTime={moment().toDate()} minDate={moment().toDate()} onChange={date => {
            this.setState({order: {...this.state.order, requestedDateTime: date}})
          }} dateFormat={'YYYY-MM-DD'} inputProps={{placeholder: 'As soon as possible.'}} timeFormat={'HH:mm'} renderInput={props =>
            <div className='input-group'>
              <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
              <input {...props} className='form-control' />
            </div>
          } />
          {this.state.order.operation === 'ACTIVATE' &&
          <div className='row'>
            <LinkedInputGroup ref={(form) => { this.form = form }}>
              <div className='col-md-12'>
                <label>Your Internal Reference</label>
                <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='order.spReference' />
              </div>
              <div className='col-md-12'>
                <label>Your subscription ID</label>
                <LinkedInput context={this} path='order.spSubscriptionId' />
              </div>
            </LinkedInputGroup>
            {this.state.order && this.state.order.operation === 'ACTIVATE' && this.state.order.characteristics && <CharacteristicsWidget updated={this.props.updated} getCharacteristics={characteristics => (this.setCharacteristics = characteristics)} characteristics={this.state.order.characteristics} editable />}
          </div>
          }
          {this.state.activating && <NoContentBox icon='circle-o-notch fa-spin' text='' />}
        </Modal>
      </StaticBox>
    )
  }
}
export default AccessOrders



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/access/AccessOrders.js